/* eslint-disable import/no-unresolved */
import { Navigate } from "react-router-dom";
import Landing from "src/components/Landing";

interface Props {
  status: Boolean;
}
function LandingPage({ status }: Props) {
  return !status ? <Landing /> : <Navigate to="/dashboard" />;
}

export default LandingPage;
